import { HttpErrorResponse } from '@angular/common/http';
import { MAINTENANCE_HEADER } from '$core/constants/maintenance-header';

/**
 * Whether the error is a `503` our backend marked as its own planned
 * maintenance with the `X-Maintenance` header. An unmarked `503` is an
 * external/infrastructure outage and returns `false`, so it is not shown the
 * maintenance page.
 */
export function isMaintenance(error: unknown): boolean {
  return (
    error instanceof HttpErrorResponse &&
    error.status === 503 &&
    error.headers.has(MAINTENANCE_HEADER)
  );
}
